// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1vcMt","FooterWrap":"Footer_FooterWrap__3NCbd","FooterLinks":"Footer_FooterLinks__xt08-","Copyright":"Footer_Copyright__1Pqrt"};